module.exports = __webpack_public_path__ + "img/1927_v5.bc4df966.png";